function getQueryParam(param) {
  var params = new URLSearchParams(window.location.search);
  return params.get(param);
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

doOptimiseMedia();
doInvolveAsia()

function doOptimiseMedia() {
  var sskey = getQueryParam('SSKEY');
  if (sskey) {
    setCookie('optimisemedia_sskey', sskey, 15);
  }
}

function doInvolveAsia() {
  if (getQueryParam('utm_source') && getQueryParam('utm_source') == 'involveasia') {
    setCookie('affiliate_id', getQueryParam('utm_medium').split("_")[0], 15);
    setCookie('transaction_id', getQueryParam('utm_medium').split("_")[1], 15);
    setCookie('offer_id', getQueryParam('offer_id'), 15);
    setCookie('click_id', getQueryParam('click_id'), 15);
  }
}
